module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showPlusses,
      "caption": this.showPlusses ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showPlusses = !_vm.showPlusses
      }
    }
  }, [_c('span', [_vm._v(" Поставки (" + _vm._s(_vm.plusses.length) + "):\n      "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.plussesSum, _vm.formats.formatNumber)) + " руб.")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlusses),
      expression: "showPlusses"
    }]
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((_vm.plusses), function(item, i) {
    return [_c('v-list-tile', {
      key: 'p' + i
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s('Поставка ' + '<b>' + item.amount + '</b>' + ' руб.')
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.note))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.date, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showMinuses,
      "caption": this.showMinuses ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showMinuses = !_vm.showMinuses
      }
    }
  }, [_c('span', [_vm._v("Платежи (" + _vm._s(_vm.minuses.length) + "):\n      "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.minusesSum, _vm.formats.formatNumber)) + "  руб.")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMinuses),
      expression: "showMinuses"
    }]
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((_vm.minuses), function(item, i) {
    return [_c('v-list-tile', {
      key: 'm' + i
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s('Платеж ' + '<b>' + item.amount + '</b>' + ' руб.')
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.note))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.date, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showParams,
      "caption": this.showParams ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showParams = !_vm.showParams
      }
    }
  }, [_vm._v("\n      Параметры расчета:\n    "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.params.startType === 'RELEASE' ? 'Дата поставки' : 'Начало просрочки') + ": "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.params.start, _vm.formats.formatDate)))])]), _vm._v(" - "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.params.end, _vm.formats.formatDate)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.params.rateType === 'DAY' && _vm.params.rates && _vm.params.rates.length === 1 ? ("Ставка " + (this.formatPercent(_vm.params.rates[0].percent)) + " в день") : "Сложная ставка"))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(("Отсрочка платежа " + (_vm.formats.blank(_vm.params.lateDays, _vm.formats.formatNumber)))))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_c('span', [_vm._v(_vm._s(_vm.params.minusType !== 'BASE_ONLY' || _vm.params.periodType !== 'DAYS_365' || _vm.params.dutyType !== "ARBITR" ? 'Не стандартные параметры' : ''))])])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showParams),
      expression: "showParams"
    }],
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "mt-3": "",
      "row": "",
      "wrap": "",
      "justify-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Начало расчета",
      "items": _vm.startDayItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.startType),
      callback: function($$v) {
        _vm.$set(_vm.params, "startType", $$v)
      },
      expression: "params.startType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs5": ""
    }
  }, [(_vm.params.startType !== 'RELEASE') ? _c('v-date-field', {
    attrs: {
      "label": "Начало просрочки",
      "rules": _vm.startDateRules,
      "error-messages": _vm.errorDateOrder(),
      "hint": _vm.hints.startDate,
      "min": _vm.getFirstStartDateString(),
      "calendarOnly": _vm.isCalendarOnly
    },
    model: {
      value: (_vm.params.start),
      callback: function($$v) {
        _vm.$set(_vm.params, "start", $$v)
      },
      expression: "params.start"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.params.startType === 'RELEASE') ? _c('v-date-field', {
    attrs: {
      "label": "Дата поставки",
      "rules": _vm.startDateReleaseRules,
      "error-messages": _vm.errorDateOrder(),
      "hint": _vm.hints.startDateRelease,
      "min": _vm.getFirstStartDateString(),
      "calendarOnly": _vm.isCalendarOnly
    },
    model: {
      value: (_vm.params.start),
      callback: function($$v) {
        _vm.$set(_vm.params, "start", $$v)
      },
      expression: "params.start"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "xs5": ""
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "Конец",
      "rules": _vm.endDateRules,
      "error-messages": _vm.errorDateOrder(),
      "hint": _vm.hints.endDate,
      "calendarOnly": _vm.isCalendarOnly
    },
    model: {
      value: (_vm.params.end),
      callback: function($$v) {
        _vm.$set(_vm.params, "end", $$v)
      },
      expression: "params.end"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-2": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "value.calcType": ""
    }
  }, [_vm._v("\n        Процентные ставки:\n        "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addPercent()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": ""
    }
  }, _vm._l((_vm.rates), function(item, i) {
    return _c('v-card', {
      key: 'rate' + i
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-space-around": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm2": "",
        "xs3": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": _vm.isDisabledRate(i),
        "label": "с (дня)"
      },
      model: {
        value: (item.from),
        callback: function($$v) {
          _vm.$set(item, "from", $$v)
        },
        expression: "item.from"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": "",
        "xs3": ""
      }
    }, [_c('v-number-field', {
      attrs: {
        "label": "ставка, %"
      },
      model: {
        value: (item.percent),
        callback: function($$v) {
          _vm.$set(item, "percent", $$v)
        },
        expression: "item.percent"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pt-2": "",
        "sm1": "",
        "xs2": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "disabled": _vm.isDisabledRate(i),
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deletePercent(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("clear")])], 1)], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Размер ставки",
      "items": _vm.rateTypeItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.rateType),
      callback: function($$v) {
        _vm.$set(_vm.params, "rateType", $$v)
      },
      expression: "params.rateType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-number-field', {
    attrs: {
      "label": "Отсрочка оплаты, в днях."
    },
    model: {
      value: (_vm.params.lateDays),
      callback: function($$v) {
        _vm.$set(_vm.params, "lateDays", $$v)
      },
      expression: "params.lateDays"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Очередность погашения",
      "items": _vm.minusTypeItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.minusType),
      callback: function($$v) {
        _vm.$set(_vm.params, "minusType", $$v)
      },
      expression: "params.minusType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Период определять",
      "items": _vm.periodTypeItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.periodType),
      callback: function($$v) {
        _vm.$set(_vm.params, "periodType", $$v)
      },
      expression: "params.periodType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Расчет гос.пошлины",
      "items": _vm.calcDutyItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.dutyType),
      callback: function($$v) {
        _vm.$set(_vm.params, "dutyType", $$v)
      },
      expression: "params.dutyType"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a88fd57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/fields/CalcPanel.vue
// module id = 938
// module chunks = 1